export default __webpack_public_path__ + "static/media/search.e510cbe9.svg";